import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
// import wxShare from '@/wx/wxShare'

Vue.use(Router)

let channalId = 'ORG0000000000001';
Vue.prototype.KHchannalId = channalId;


/**
 * 医生团队-医生订单
//  */
// const doctorOrder = (resolve) => {
// 	import('@/view/doctor/doctorOrder').then((module) => {
// 		resolve(module)
// 	})
// }

const router = new Router({
    scrollBehavior (to, from, savedPosition) {
		return { x: 0, y: 0 }
    },
    routes: [
        {
            path: '/member/index/:channalId',
            name: '会员',
            component: (resolve) => require(['@/views/member/index'],resolve),
            meta: {
                noLogin: false
            }
        },{
            path: '/login/:channalId',
			name: '登录',
			component: (resolve) => require(['@/views/login'],resolve),
			meta: {
				noLogin: true
			}
        },{
			path: '/fastLogin/:channalId',
			name: '快速登录',
			component: (resolve) => require(['@/views/fastLogin'],resolve),
			meta: {
				noLogin: true
			}
		},
		{
			path: '/resetPassword/:channalId',
			name: '修改密码',
			component: (resolve) => require(['@/views/resetPassword'],resolve),
			meta: {
				noLogin: true
			}
		},{
			path: '/termOfService/:channalId',
			name: '服务条款',
			component: (resolve) => require(['@/views/termOfService'],resolve),
			meta: {
				noLogin: true
			}
		},{
			path: '/appBridge/:channalId',
			name: '加载中',
			component: (resolve) => require(['@/views/appBridge'],resolve),
			meta: {
				noLogin: true
			}
        },{
            path: '/member/newMember/:channalId',
            name: '新会员',
            component: (resolve) => require(['@/views/member/newMember'],resolve),
            meta: {
                noLogin: false
            }
        },{
            path: '/member/myService/:channalId',
            name: '我服务的',
            component: (resolve) => require(['@/views/member/service'],resolve),
            meta: {
                noLogin: false
            }
        },{
            path: '/member/memberHomePage/:channalId',
            name: '会员主页',
            component: (resolve) => require(['@/views/member/memberIndex'],resolve),
            meta: {
                noLogin: false
            }
        },{
            path: '/member/member/:channalId',
            name: '会员信息',
            component: (resolve) => require(['@/views/member/member'],resolve),
            meta: {
                noLogin: false
            }
        },{
            path: '/indexData/index/:channalId',
            name: '指标数据',
            component: (resolve) => require(['@/views/indexData/index'],resolve),
            meta: {
                noLogin: false
            }
        },{
            path: '/medicalRecord/index/:channalId',
            name: '病历报告',
            component: (resolve) => require(['@/views/medicalRecord/index'],resolve),
            meta: {
                noLogin: false
            }
        },{
            path: '/physicalRecord/index/:channalId',
            name: '体检报告',
            component: (resolve) => require(['@/views/physicalReport/index'],resolve),
            meta: {
                noLogin: false
            }
        },{
            path: '/evalRecord/index/:channalId',
            name: '测评记录',
            component: (resolve) => require(['@/views/evalRecord/index'],resolve),
            meta: {
                noLogin: false
            }
        },{
            path: '/evalRecord/detail/:channalId',
            name: '测评详情',
            component: (resolve) => require(['@/views/evalRecord/detail'],resolve),
            meta: {
                noLogin: false
            }
        },{
            path: '/guideRecord/index/:channalId',
            name: '指导方案',
            component: (resolve) => require(['@/views/guide/index'],resolve),
            meta: {
                noLogin: false
            }
        },{
            path: '/guideRecord/detail/:channalId',
            name: '方案详情',
            component: (resolve) => require(['@/views/guide/detail'],resolve),
            meta: {
                noLogin: false
            }
        },{
            path: '/evalRecord/assess/assess/:channalId',
            name: '量表详情',
            component: (resolve) => require(['@/views/evalRecord/assess/assess'],resolve),
            meta: {
                noLogin: true
            } 
        },{
            path: '/evalRecord/assess/assesss/:channalId',
            name: '量表',
            component: (resolve) => require(['@/views/evalRecord/assess/assesss'],resolve),
            meta: {
                noLogin: true
            } 
        },{
            path: '/evalRecord/result/result/:channalId',
            name: '量表测评结果',
            component: (resolve) => require(['@/views/evalRecord/result/result'],resolve),
            meta: {
                noLogin: false
            }
        },{
            path: '/evalRecord/result/results/:channalId',
            name: '测评结果',
            component: (resolve) => require(['@/views/evalRecord/result/results'],resolve),
            meta: {
                noLogin: false
            }
        },{
            path: '/evalRecord/reneweval/:channalId',
            name: '重新测评',
            component: (resolve) => require(['@/views/evalRecord/reneweval'],resolve),
            meta: {
                noLogin: false
            }
        },{
            path: '/evalRecord/goStart/:channalId',
            name: '去测评',
            component: (resolve) => require(['@/views/evalRecord/goStart'],resolve),
            meta: {
                noLogin: false
            }
        },{
            path: '/evalRecord/start/:channalId',
            name: '测评',
            component: (resolve) => require(['@/views/evalRecord/start'],resolve),
            meta: {
                noLogin: false
            }
        },{
            path: '/platform/guidePlan/index/:channalId',
            name: '指导方案',
            component: (resolve) => require(['@/views/platform/guidePlan/index'],resolve),
            meta: {
                noLogin: false
            }
        },{
            path: '/platform/guidePlan/detail/:channalId',
            name: '指导方案详情',
            component: (resolve) => require(['@/views/platform/guidePlan/detail'],resolve),
            meta: {
                noLogin: false
            }
        },{
            path: '/platform/guidePlan/editGuidePlan/:channalId',
            name: '编辑指导方案',
            component: (resolve) => require(['@/views/platform/guidePlan/editGuidePlan'],resolve),
            meta: {
                noLogin: false
            }
        },{
            path: '/platform/guidePlan/member/:channalId',
            name: '会员选择',
            component: (resolve) => require(['@/views/platform/guidePlan/member'],resolve),
            meta: {
                noLogin: false
            }
        },{
            path: '/platform/guidePlan/guidePlans/:channalId',
            name: '选择指导方案',
            component: (resolve) => require(['@/views/platform/guidePlan/guidePlans'],resolve),
            meta: {
                noLogin: false
            }
        },{
            path: '/platform/guidePlan/evalRecords/:channalId',
            name: '选择测评记录',
            component: (resolve) => require(['@/views/platform/guidePlan/evalRecords'],resolve),
            meta: {
                noLogin: false
            }
        },{
            path: '/platform/guidePlan/createGuidePlan/:channalId',
            name: '生成指导方案',
            component: (resolve) => require(['@/views/platform/guidePlan/createGuidePlan'],resolve),
            meta: {
                noLogin: false
            }
        },{
			path: '/doctor/doctorOrder/:channalId',
			name: '医生订单',
			component: (resolve) => require(['@/views/doctor/doctorOrder'],resolve),
			// component: (resolve) => require(['@/view/doctor/personal'], resolve),
			meta: {
				noLogin: true
			}
		}
    ]
})

router.beforeEach((to, from, next) => {
    let user = sessionStorage.getItem("user");
    if(user){
        next()
    }else{
        if(to.meta && to.meta.noLogin){
            // console.log('no-user-1')
            // KHGetUserInfo({
            //     environment:1,
            //     jwtToken:"eyJhbGciOiJIUzUxMiJ9.eyJiaXJ0aGRheSI6Nzg4Mjg0ODAwMDAwLCJzdWIiOiJBQ0MxNTUyMjg1OTY3ODcwMjQ3X3N5c1R5cGVfMSIsImFjY291bnRDb2RlIjoiQUNDMTU1MjI4NTk2Nzg3MDI0NyIsInN0YWZmQ29kZSI6IktNUlkxNTUyNDQzMzY0NzcyMzQiLCJzZXgiOiJGIiwidGVjaG5pY2FsQ29kZSI6IktNWkMxNTM5NjkxNTI0OTI0OTMiLCJwb3J0cmFpdCI6Imh0dHBzOi8vaW1nMDEua2FuZ2hlaGVhbHRoLmNvbS9zdGF0aWMvaW1hZ2VzL2FhL2UyL2E3L2ZjLzhiYmZlMGUwNGU3ZDQyZGM5MTlhNGY4YmY2Y2E0OTdlLnBuZyIsInRlY2huaWNhbE5hbWUiOiLkuLvmsrvljLvluIgiLCJjbGllbnRUeXBlIjoiMSIsInBob25lIjoiMTM3MjYyNjg1NTkiLCJleHAiOjE1NzkwNTY3MTQsImlhdCI6MTU3ODQ1MTkxNCwic3RhdHVzIjoxfQ.gntWPJQTwNWkyHBtxhxJGHKncL0F2dFLDz68iEqrWu1LtXmxhftrwCAvrDWP_V63AuYUAqj3pBfQQY1PnJ3tmQ",
            //     memberCode:'KMHY1560225391033862',
            //     staffCode: 'KMRY155321947416487',
            //     type:0
            // })
            next()
        }else{
            console.log('no-user-2')
            router.push({path:"/login/"+ channalId})
        }
    }
})


export default router;


// WEBPACK FOOTER //
// ./src/router/index.js